import { useContext } from "react";
import NotificationContext from "../Contexts/NotificationContext";

const useNotification = () => useContext(NotificationContext);

export default useNotification;
